import { css } from "styled-components";
import { darken } from "polished";
import Colors from "constants/Colors";
import { FiraSansBold } from "../Text";
import globalStyles from "../../../globalStyles";

const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
  return css`
    color: ${color};
    background-color: ${bg};
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      background-color: ${bgFocus};
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
    }
    &:active:not(:disabled) {
      background-color: ${bgActive};
    }
    ${args.length >= 1 ? args.join("\n") : ""}
  `;
};

const primaryMixin = generateStyle(
  globalStyles.components.button.primaryMixin.primary,
  globalStyles.components.button.primaryMixin.secondary,
  darken(0.1, globalStyles.components.button.primaryMixin.secondary),
  darken(0.2, globalStyles.components.button.primaryMixin.secondary)
);
const secondaryMixin = generateStyle(
  globalStyles.components.button.secondaryMixin.primary,
  globalStyles.components.button.secondaryMixin.secondary,
  darken(0.1, globalStyles.components.button.secondaryMixin.secondary),
  darken(0.2, globalStyles.components.button.secondaryMixin.secondary)
);
const thirdMixin = generateStyle(
  globalStyles.components.button.thirdMixin.primary,
  globalStyles.components.button.thirdMixin.secondary,
  darken(0.1, globalStyles.components.button.thirdMixin.terciary),
  darken(0.2, globalStyles.components.button.thirdMixin.quaternary)
);

const outlinePrimaryMixin = css`
  border: 1px ${({ dashed }) => (dashed ? "dashed" : "solid")}
    ${globalStyles.components.button.outlinePrimaryMixin.secondary};
  ${FiraSansBold};
  color: ${globalStyles.components.button.thirdMixin.primary};
  padding: 4px 16px;
  text-transform: none;
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${globalStyles.components.button.thirdMixin.secondary};
    background: ${globalStyles.components.button.thirdMixin.secondary};
  }
  &:active:not(:disabled) {
    background-color: ${darken(
      0.2,
      globalStyles.components.button.thirdMixin.secondary
    )};
  }
`;

const blueMixin = generateStyle(
  globalStyles.components.button.blueMixin.primary,
  globalStyles.components.button.blueMixin.secondary,
  darken(0.1, globalStyles.components.button.blueMixin.secondary),
  darken(0.2, globalStyles.components.button.blueMixin.secondary)
);

const forthMixin = css`
  padding-left: 0 !important;
  margin-left: 0 !important;
  padding-right: 0 !important;
  text-align: left !important;
  color: ${globalStyles.components.button.forthMixin.primary};
`;

const grayTextMixin = css`
  padding: 8px 0;
  color: ${Colors.GRAY[0]};
  &:active:not(:disabled) {
    color: ${Colors.GRAY[3]};
  }
`;

const noBorderPrimaryMixin = css`
  color: ${globalStyles.components.button.noBorderPrimaryMixin.secondary};
  padding: 6px 16px;
  ${FiraSansBold};
  text-transform: none;
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${globalStyles.components.button.noBorderPrimaryMixin.primary};
  }
  &:active:not(:disabled) {
    color: ${globalStyles.components.button.noBorderPrimaryMixin.primary};
  }
`;

const smallMixin = css`
  height: 32px;
`;

export {
  primaryMixin,
  outlinePrimaryMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  smallMixin,
  secondaryMixin,
  thirdMixin,
  forthMixin,
  generateStyle,
  blueMixin
};